import React, {Component} from 'react'
import { Row, Col, Card, CardHeader, CardBody } from 'reactstrap'
import gql from 'graphql-tag'
import { graphql } from 'react-apollo'
import PropTypes from 'prop-types'

class Article extends Component {

  static propTypes = {
    data: PropTypes.object.isRequired
  };

  render() {
    if (this.props.data.loading) {
      return (<div>Loading</div>)
    }

    if (this.props.data.error) {
      if (this.props.data.error.networkError.statusCode === 404) {
        return (<div>Not Found</div>)
      } else {
        return (<div>An unexpected error occurred</div>)
      }
    }

    return (
      <div className="article">
        <Row>
          <Col>
            <Card>
              <CardHeader>
                <b>
                  {this.props.data.article.title}
                </b>
              </CardHeader>
              <CardBody>
                {this.props.data.article.body}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    )
  }
}

const ArticleFetchQuery = gql`
  query ArticleFetchQuery($article_id: ID!) {
    article(article_id: $article_id) {
      id, title, body
    }
  }
`
const ArticleWithData = graphql(ArticleFetchQuery, {
  options: (props) => ({
    fetchPolicy: 'network-only',
    variables: {article_id: props.match.params.id}
  }),
})(Article)

export default ArticleWithData



// WEBPACK FOOTER //
// ./src/components/Dictionary/Article.js